<template>


    <component :is="UserActivityTileFactory.getComponent(userActivity.userActivityType)" :userActivity="userActivity"
        v-for="(userActivity, index) in userActivities" :key="index" class="px-4">
    </component>

</template>







<script setup>

import { computed } from "vue";
import { LiveUserActivityStore } from '@/store/liveUserActivityStore';
import UserActivityTileFactory from '@/utils/ComponentFactory/UserActivityTileFactory';

const liveUserActivityStore = LiveUserActivityStore();
const userActivities = computed(() => { return liveUserActivityStore.userActivities; });

</script>